const getOtherFilters = (otherFilters, sortValue) => {
    if(!_.isEmpty(otherFilters)) {
        if(null === sortValue) {
            Object.keys(otherFilters).map((fId, index) => {
                if(0 === index) {
                    sortValue = '?' +  otherFilters[fId]
                } else {
                    sortValue += '&' + otherFilters[fId]
                }
            })
        } else {
            Object.keys(otherFilters).map(fId => {
                sortValue += '&' + otherFilters[fId]
            })
        }
    }

    return sortValue
}

export default getOtherFilters